/* eslint-disable @typescript-eslint/no-unused-vars */
import { makeAutoObservable, toJS } from 'mobx';

export default class EnumResumeDetailStore {
  constructor() {
    makeAutoObservable(this);
  }

  genderEnum;

  idTypeEnum;

  diplomaEnum;

  cityEnum;

  schoolEnum;

  majorEnum;

  collageEnum;

  degreeEnum;

  scoreRankingEnum;

  laboratoryLevelEnum;

  collegeEnum;

  companyEnum;

  workTypeEnum;

  languageEnum;

  languageLevelEnum;

  languageExaminationEnum;

  skillEnum;

  skillLevelEnum;

  thesisLevelEnum;

  authorOrderEnum;

  competitionEnum;

  socialAccountEnum;

  // 是否统招，是否全日制枚举值
  unifiedEntranceEnum = [
    { label: '是', value: '1' },
    { label: '否', value: '0' },
  ];

  // 设置枚举值
  setEnumData = (type: string, data: any) => {
    this[type] = data;
  };
}
